import PaginationUI from "@/shared/components/atoms/PaginationUI";
import TableListInternalChats from "@/shared/components/organisms/TableListInternalChats";

import { FC } from "react";
import { useNavigate } from "react-router-dom";

export const InternalChats: FC<any> = () => {
  const chats = [
    {
      id: 1,
      tittle: "Bienvenida al grupo",
      state: "Publicado",
      typeReaction: "Texto",
    },
    {
      id: 2,
      tittle: "Nueva actualización disponible",
      state: "Borrador",
      typeReaction: "Emoticonos",
    },
    {
      id: 3,
      tittle: "Recordatorio de evento",
      state: "Publicado",
      typeReaction: "ninguno",
    },
    {
      id: 4,
      tittle: "Invitación a reunión",
      state: "Borrador",
      typeReaction: "Texto",
    },
    {
      id: 5,
      tittle: "Documento compartido",
      state: "Publicado",
      typeReaction: "Emoticonos",
    },
  ];
  const navigate = useNavigate();
  const navigateToInventory = () => {
    navigate("/brand/InternalChats/posts-masters");
  };
  return (
    <div className="flex flex-col items-center justify-center h-full w-full mt-8">
      <div className="w-full sm:max-w-full md:max-w-full lg:max-w-full xl:max-w-full 2xl:max-w-full mx-auto mb-8">
        <TableListInternalChats
          chats={chats}
          functionButton={navigateToInventory}
        />
        <PaginationUI
          currentPage={1}
          totalPages={1}
          onPageChange={() => {}}
          pageSize={10}
          totalResults={5}
        />
      </div>
    </div>
  );
};
